import { IconButton, Tooltip } from '@mui/material';
import { Link } from 'react-router-dom';
import { DetailsButtonProps } from './types';
import { Details } from '@mui/icons-material';

const DetailsButton: React.FunctionComponent<DetailsButtonProps> = ({ disabled, title, to }) => {
  return (
    <Tooltip title={title}>
      <IconButton component={Link} disabled={disabled} size='small' to={to}>
        <Details fontSize='small' />
      </IconButton>
    </Tooltip>
  );
};

export default DetailsButton;
